module.exports = __webpack_public_path__ + "static/media/tk.90381c85.svg";